import React from 'react';

export default function ClientsToolbar({
  active, plans, planId, onPlanChange,
  q, onQChange, onApplySearch, total
}) {
  return (
    <div className="cv2-toolbar">
      <div className="cv2-toolbar__title-block">
        <div className="cv2-toolbar__icon"><i className="fas fa-users" /></div>
        <div>
          <h2 className="cv2-toolbar__title">
            Clientes {active ? 'activos' : 'inactivos'}
          </h2>
          <p className="cv2-toolbar__subtitle">
            {total != null ? `${total} ${total === 1 ? 'cliente' : 'clientes'}` : 'Cargando…'}
          </p>
        </div>
      </div>

      <div className="cv2-toolbar__filters">
        <a href="/settings/clients_v2/dashboard" className="cv2-btn cv2-btn--primary">
          <i className="fas fa-chart-line" /> Dashboard ejecutivo
        </a>
        {plans?.length > 1 && (
          <select
            className="cv2-select"
            value={planId || ''}
            onChange={e => onPlanChange(Number(e.target.value))}
            disabled={!!q}
            title={q ? 'La búsqueda activa busca en TODOS los planes' : 'Filtrar por plan'}
          >
            {plans.map(p => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        )}
        {q && (
          <span className="cv2-badge-info" title="Mientras buscas, se ignora el filtro de plan">
            <i className="fas fa-globe" /> Buscando en todos los planes
          </span>
        )}

        <div className="cv2-search">
          <i className="fas fa-search" />
          <input
            type="text"
            placeholder="Buscar por nombre, NIT o email…"
            value={q}
            onChange={e => onQChange(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && onApplySearch()}
          />
          {q && (
            <button className="cv2-search__clear" onClick={() => { onQChange(''); onApplySearch(); }}>
              <i className="fas fa-times" />
            </button>
          )}
          <button className="cv2-btn cv2-btn--primary" onClick={onApplySearch}>Buscar</button>
        </div>
      </div>
    </div>
  );
}
